import { createContext } from "react";
import SnackbarErrorContextProps from "./models/ErrorContextProps";

const SnackbarErrorContext = createContext<SnackbarErrorContextProps>(
  {} as SnackbarErrorContextProps
);

export default SnackbarErrorContext;
